import {Experiment} from '../reducers/experiments';
import {allUpdates, allUpdatesNew, productsCategories, Route, filterCategoriesNew} from '../routes/navigation';
import {createSelector} from 'reselect';
import {experimentsSelector} from './experiments';

const specificTopItems = [
  allUpdates.label,
  'navigation.wix.editor',
  'navigation.wix.adi',
  'navigation.wix.velo',
  'navigation.wix.promote',
  'navigation.wix.stores',
];

const additionalItems = [
  'navigation.wix.bookings',
  'navigation.wix.seo.wiz',
  'navigation.wix.pro.gallery',
  'navigation.wix.logo',
  'navigation.wix.restaurants',
  'navigation.wix.music',
  'navigation.wix.events',
  'navigation.wix.forums',
  'navigation.wix.video',
  'navigation.wix.blog',
  'navigation.wix.app.market',
  'navigation.wix.home',
  'navigation.payments',
];

const tags = [
  allUpdatesNew.label,
  'navigation.new.features',
  'navigation.features.updates',
  'navigation.bug.fixes',
];

export const productsSelector = createSelector(experimentsSelector, (experiments: Experiment[]): Route[] => {
  return [allUpdates].concat(
    productsCategories.slice(0)
      .filter(labelFilter(...specificTopItems))
    )
    .map((invisible: Route): Route => ({
      ...invisible,
      show: true,
      menuLevel: 1,
    }))
    .sort(labelSort(...specificTopItems));
});

export const additionalProductsSelector = createSelector(experimentsSelector, (experiments: Experiment[]): Route[] => {
  return productsCategories.slice(0)
    .filter(labelFilter(...additionalItems))
    .map((item: Route): Route => ({...item, show: true}))
    .sort(labelSort(...additionalItems));
});

export const tagsSelector = createSelector(experimentsSelector, (): Route[] => {
  return filterCategoriesNew.slice(0)
    .filter(labelFilter(...tags))
    .map((invisible: Route, index): Route => ({
      ...invisible,
      show: true,
    }))
    .sort(labelSort(...tags));
});

function labelFilter(...label): (item: Route) => boolean {
  return (item) => label.includes(item.label);
}

function labelSort(...label): (i1: Route, i2: Route) => number {
  return (itemA, itemB) => label.indexOf(itemA.label) - label.indexOf(itemB.label);
}
